import React from 'react';

import {
  createTheme,
  ThemeProvider,
  useTheme
} from '@mui/material';

import * as dataService from './dataService';



export interface IProps {
  storeId: string;
  children: React.ReactNode;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.storeId);
  const existingTheme = useTheme();



  const theme = React.useMemo(
    () => createTheme({
      ...existingTheme,
      palette: {
        ...existingTheme.palette,
        primary: {
          main: queryTuple.data.primaryColor || existingTheme.palette.primary.main
        },
        secondary: {
          main: queryTuple.data.secondaryColor || existingTheme.palette.secondary.main
        },
        success: {
          main: queryTuple.data.primaryColor || existingTheme.palette.success.main
        }
      },
      components: {
        ...existingTheme.components,
        MuiButton: {
          styleOverrides: {
            containedSuccess: {
              backgroundColor: queryTuple.data.buttonColor
            }
          }
        },
        MuiToggleButton: {
          styleOverrides: {
            root: {
              backgroundColor: 'white'
            }
          }
        }
      }
    }),
    [
      queryTuple,
      existingTheme
    ]
  );



  return !queryTuple.loading ? (
    <ThemeProvider theme={theme}>
      {props.children}
    </ThemeProvider>
  ) : null;
};
